import { useState, useCallback } from 'react';
import { Movement } from '../types/movement';

type FilterState = {
  search: string;
  type: string;
  fromCity: string;
  toCity: string;
  dateRange: {
    start: string;
    end: string;
  };
  timeRange: {
    start: string;
    end: string;
  };
  minPilgrims: string;
  maxPilgrims: string;
};

const initialState: FilterState = {
  search: '',
  type: 'all',
  fromCity: 'all',
  toCity: 'all',
  dateRange: {
    start: '',
    end: ''
  },
  timeRange: {
    start: '',
    end: ''
  },
  minPilgrims: '',
  maxPilgrims: ''
};

export const useMovementFilters = (movements: Movement[]) => {
  const [filters, setFilters] = useState<FilterState>(initialState);

  const handleFilterChange = (key: keyof FilterState, value: any) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const clearFilters = () => {
    setFilters(initialState);
  };

  const filteredMovements = movements.filter(movement => {
    // Search filter
    const matchesSearch = !filters.search || 
      movement.name.toLowerCase().includes(filters.search.toLowerCase()) ||
      movement.from.name.toLowerCase().includes(filters.search.toLowerCase()) ||
      movement.to.name.toLowerCase().includes(filters.search.toLowerCase());

    // Type filter
    const matchesType = filters.type === 'all' || movement.type === filters.type;

    // City filters
    const matchesFromCity = filters.fromCity === 'all' || movement.from.city === filters.fromCity;
    const matchesToCity = filters.toCity === 'all' || movement.to.city === filters.toCity;

    // Date range filter
    const movementDate = new Date(movement.departureDate.split('/').reverse().join('-'));
    const matchesDateRange = (!filters.dateRange.start || movementDate >= new Date(filters.dateRange.start)) &&
                           (!filters.dateRange.end || movementDate <= new Date(filters.dateRange.end));

    // Time range filter
    const movementTime = movement.departureTime.split(' ')[0];
    const matchesTimeRange = (!filters.timeRange.start || movementTime >= filters.timeRange.start) &&
                           (!filters.timeRange.end || movementTime <= filters.timeRange.end);

    // Pilgrims count filter
    const matchesPilgrims = (!filters.minPilgrims || movement.pilgrimsCount >= Number(filters.minPilgrims)) &&
                           (!filters.maxPilgrims || movement.pilgrimsCount <= Number(filters.maxPilgrims));

    return matchesSearch && 
           matchesType && 
           matchesFromCity && 
           matchesToCity && 
           matchesDateRange && 
           matchesTimeRange && 
           matchesPilgrims;
  });

  return {
    filters,
    handleFilterChange,
    clearFilters,
    filteredMovements
  };
};